import { RaceBy } from "@uiball/loaders";

export const Loading = () => {
  return (
    <div className="w-full flex justify-center pt-[20%] pb-10 items-center">
      <RaceBy size={200} lineWeight={5} speed={1.4} color="black" />
    </div>
  );
};
